import TeamBanner from "assets/img/homepage/team-card.svg";
import CareBanner from "assets/img/homepage/care-card.svg";
import TeamQueryBanner from "assets/img/homepage/team-query-card.svg";
import HelpDocBanner from "assets/img/homepage/help-document-card.svg";
import DashboardBanner from "assets/img/homepage/dashboard-card.svg";
import TeamAwareBanner from "assets/img/homepage/team-aware-card.svg";
import HSDBanner from "assets/img/homepage/hsd-card.svg";

import HelpLogo from "assets/img/homepage/help-card-logo.svg";
import DashboardLogo from "assets/img/homepage/dashboard-card-logo.svg";
import HSDLogo from "assets/img/homepage/hsd-card-logo.svg";
import teamCareurl from "util/url";
import { storage } from "util/localStorage";

const { careUrl, teamUrl } = teamCareurl();
const HSDDashboardId = process.env.REACT_APP_HSD_DASHBOARD_ID || "aff3f41d-88cf-4a57-84f9-8100a768a86c";

export const NavigationCardData = [
    {
        id: 1,
        title: "TEAM",
        cardSubTitle: "Patient Flow Overview",
        banner: TeamBanner,
        cardDesc: "Analyze referrals, market share, and provider networks with advanced data visualization and reporting.",
        btnText: "View Details",
        redirectUrl: teamUrl,
        csr: false,
        alt: "team card banner"
    },
    {
        id: 2,
        title: "QUERY",
        cardSubTitle: "Custom Claims Analysis",
        banner: TeamQueryBanner,
        cardDesc: "Run detailed queries for granular insights into provider performance, patient flow, and market trends",
        btnText: "Query Data",
        redirectUrl: "/openquery",
        csr: true,
        alt: "query card banner"
    },
    {
        id: 3,
        title: "AWARE",
        cardSubTitle: "Provider Relationship Trending",
        banner: TeamAwareBanner,
        cardDesc: "Automated tool delivers monthly dashboards on physician and facility market share, highlighting patient out-migration and volume changes.",
        btnText: "Create Reports",
        redirectUrl: "/aware",
        csr: true,
        alt: "aware card banner"
    },
    {
        id: 4,
        title: "Dashboards",
        cardSubTitle: "Custom Dashboards",
        banner: DashboardBanner,
        cardDesc: "Interactive dashboards reveal care patterns and trends.",
        btnText: "Explore",
        redirectUrl: "/dashboards",
        csr: true,
        logo: DashboardLogo,
        alt: "dashboard card banner"
    },
    {
        id: 5,
        title: "Health Service Demand",
        cardSubTitle: "Future Care Demand Forecasting",
        banner: HSDBanner,
        cardDesc: "Assess future care needs through geographic, demographic, and care delivery trends.",
        btnText: "View Insights",
        redirectUrl: `/healthservicedemand/${HSDDashboardId}`,
        csr: true,
        logo: HSDLogo,
        alt: "hsd card banner"
    },
    {
        id: 6,
        title: "CARE",
        cardSubTitle: "Provider Performance Ratings",
        banner: CareBanner,
        cardDesc: "Provider benchmarking tool evaluates physicians by outcome, loyalty, and other metrics for better care decisions.",
        btnText: "Review Ratings",
        redirectUrl: careUrl,
        csr: false,
        alt: "care card banner"
    },
    {
        id: 7,
        title: "Help Documents",
        cardSubTitle: "User Guide Access",
        banner: HelpDocBanner,
        cardDesc: "Comprehensive manual, glossary, and use case job aids for users.",
        btnText: "Browse Resources",
        redirectUrl: "/help",
        csr: true,
        logo: HelpLogo,
        alt: "help doc card banner"
    }
]

export const LS_KEY = "homepageCardData";

function readLocalOrder() {
    try {
        const localData = storage.getObj(LS_KEY);
        if (!localData) return null;
        return Array.isArray(localData) ? localData : null;
    } catch {
        return null;
    }
}

const byId = new Map(NavigationCardData.map(item => [item.id, item]));

export default function cardData() {
    const localdata = readLocalOrder();
    if (!localdata || localdata.length === 0 || localdata?.some(element => element === null)) {
        return [...NavigationCardData];
    }
    const mappedData = localdata.map((item) => byId.get(item));
    return mappedData;
}
